module.exports = __webpack_public_path__ + "img/bg.a91bed44.png";